export const GET_CONFIG = "GET_CONFIG";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS";
export const GET_CONFIG_FAIL = "GET_CONFIG_FAIL";

export const GET_LIST_ROLERULE = "GET_LIST_ROLERULE";
export const GET_LIST_ROLERULE_SUCCESS = "GET_LIST_ROLERULE_SUCCESS";
export const GET_LIST_ROLERULE_FAIL = "GET_LIST_ROLERULE_FAIL";

export const GET_LIST_CATE = "GET_LIST_CATE";
export const GET_LIST_CATE_SUCCESS = "GET_LIST_CATE_SUCCESS";
export const GET_LIST_CATE_FAIL = "GET_LIST_CATE_FAIL";

export const GET_CHANNELS = "GET_CHANNELS";
export const GET_CHANNELS_SUCCESS = "GET_CHANNELS_SUCCESS";
export const GET_CHANNELS_FAIL = "GET_CHANNELS_FAIL";

export const GET_LIST_PENNAME = "GET_LIST_PENNAME";
export const GET_LIST_PENNAME_SUCCESS = "GET_LIST_PENNAME_SUCCESS";
export const GET_LIST_PENNAME_FAIL = "GET_LIST_PENNAME_FAIL";

export const GET_LIST_TAG = "GET_LIST_TAG";
export const GET_LIST_TAG_SUCCESS = "GET_LIST_TAG_SUCCESS";
export const GET_LIST_TAG_FAIL = "GET_LIST_TAG_FAIL";
export const GET_LIST_TAG_MANAGE = "GET_LIST_TAG_MANAGE";
export const GET_LIST_TAG_MANAGE_SUCCESS = "GET_LIST_TAG_MANAGE_SUCCESS";
export const GET_LIST_TAG_MANAGE_FAIL = "GET_LIST_TAG_MANAGE_FAIL";
export const GET_LIST_DIMENSION = "GET_LIST_DIMENSION";
export const GET_LIST_DIMENSION_SUCCESS = "GET_LIST_DIMENSION_SUCCESS";
export const GET_LIST_DIMENSION_FAIL = "GET_LIST_DIMENSION_FAIL";

export const GET_LIST_PRAGENCY = "GET_LIST_PRAGENCY";
export const GET_LIST_PRAGENCY_SUCCESS = "GET_LIST_PRAGENCY_SUCCESS";
export const GET_LIST_PRAGENCY_FAIL = "GET_LIST_PRAGENCY_FAIL";

export const GET_COUNT_TAG = "GET_COUNT_TAG";
export const GET_COUNT_TAG_SUCCESS = "GET_COUNT_TAG_SUCCESS";
export const GET_COUNT_TAG_FAIL = "GET_COUNT_TAG_FAIL";

export const GET_LIST_ROLE = "GET_LIST_ROLE";
export const GET_LIST_ROLE_SUCCESS = "GET_LIST_ROLE_SUCCESS";
export const GET_LIST_ROLE_FAIL = "GET_LIST_ROLE_FAIL";

export const CREATE_NEW_TAG = "CREATE_NEW_TAG";
export const CREATE_NEW_TAG_SUCCESS = "CREATE_NEW_TAG_SUCCESS";
export const CREATE_NEW_TAG_FAIL = "CREATE_NEW_TAG_FAIL";
export const CREATE_NEW_SERIES = "CREATE_NEW_SERIES";
export const CREATE_NEW_SERIES_SUCCESS = "CREATE_NEW_SERIES_SUCCESS";
export const CREATE_NEW_SERIES_FAIL = "CREATE_NEW_SERIES_FAIL";
export const CREATE_NEW_DIMENSION = "CREATE_NEW_DIMENSION";
export const CREATE_NEW_DIMENSION_SUCCESS = "CREATE_NEW_DIMENSION_SUCCESS";
export const CREATE_NEW_DIMENSION_FAIL = "CREATE_NEW_DIMENSION_FAIL";

export const CREATE_NEW_PRAGENCY = "CREATE_NEW_PRAGENCY";
export const CREATE_NEW_PRAGENCY_SUCCESS = "CREATE_NEW_PRAGENCY_SUCCESS";
export const CREATE_NEW_PRAGENCY_FAIL = "CREATE_NEW_PRAGENCY_FAIL";

export const CREATE_NEW_EDITOR = "CREATE_NEW_EDITOR";
export const CREATE_NEW_EDITOR_SUCCESS = "CREATE_NEW_EDITOR_SUCCESS";
export const CREATE_NEW_EDITOR_FAIL = "CREATE_NEW_EDITOR_FAIL";
export const CREATE_NEW_PHOTO = "CREATE_NEW_PHOTO";
export const CREATE_NEW_PHOTO_SUCCESS = "CREATE_NEW_PHOTO_SUCCESS";
export const CREATE_NEW_PHOTO_FAIL = "CREATE_NEW_PHOTO_FAIL";

export const GET_LIST_POSTYPE = "GET_LIST_POSTYPE";
export const GET_LIST_POSTYPE_SUCCESS = "GET_LIST_POSTYPE_SUCCESS";
export const GET_LIST_POSTYPE_FAIL = "GET_LIST_POSTYPE_FAIL";

export const GET_CONTENT_CREATOR = "GET_CONTENT_CREATOR";
export const GET_CONTENT_CREATOR_SUCCESS = "GET_CONTENT_CREATOR_SUCCESS";
export const GET_CONTENT_CREATOR_FAIL = "GET_CONTENT_CREATOR_FAIL";

export const CREATE_CONTENT_CREATOR = "CREATE_CONTENT_CREATOR";
export const CREATE_CONTENT_CREATOR_SUCCESS = "CREATE_CONTENT_CREATOR_SUCCESS";
export const CREATE_CONTENT_CREATOR_FAIL = "CREATE_CONTENT_CREATOR_FAIL";

//penname, video, photo, designer, source
export const GET_PENNAMES = "GET_PENNAMES";
export const GET_PENNAMES_SUCCESS = "GET_PENNAMES_SUCCESS";
export const GET_PENNAMES_FAIL = "GET_PENNAMES_FAIL";
export const CREATE_PENNAMES = "CREATE_PENNAMES";
export const CREATE_PENNAMES_SUCCESS = "CREATE_PENNAMES_SUCCESS";
export const CREATE_PENNAMES_FAIL = "CREATE_PENNAMES_FAIL";

export const GET_VIDEO = "GET_VIDEO";
export const GET_VIDEO_SUCCESS = "GET_VIDEO_SUCCESS";
export const GET_VIDEO_FAIL = "GET_VIDEO_FAIL";
export const CREATE_VIDEO = "CREATE_VIDEO";
export const CREATE_VIDEO_SUCCESS = "CREATE_VIDEO_SUCCESS";
export const CREATE_VIDEO_FAIL = "CREATE_VIDEO_FAIL";

export const GET_PHOTO = "GET_PHOTO";
export const GET_PHOTO_SUCCESS = "GET_PHOTO_SUCCESS";
export const GET_PHOTO_FAIL = "GET_PHOTO_FAIL";
export const CREATE_PHOTO = "CREATE_PHOTO";
export const CREATE_PHOTO_SUCCESS = "CREATE_PHOTO_SUCCESS";
export const CREATE_PHOTO_FAIL = "CREATE_PHOTO_FAIL";

export const GET_DESIGNER = "GET_DESIGNER";
export const GET_DESIGNER_SUCCESS = "GET_DESIGNER_SUCCESS";
export const GET_DESIGNER_FAIL = "GET_DESIGNER_FAIL";
export const CREATE_DESIGNER = "CREATE_DESIGNER";
export const CREATE_DESIGNER_SUCCESS = "CREATE_DESIGNER_SUCCESS";
export const CREATE_DESIGNER_FAIL = "CREATE_DESIGNER_FAIL";

export const GET_SOURCE = "GET_SOURCE";
export const GET_SOURCE_SUCCESS = "GET_SOURCE_SUCCESS";
export const GET_SOURCE_FAIL = "GET_SOURCE_FAIL";
export const CREATE_SOURCE = "CREATE_SOURCE";
export const CREATE_SOURCE_SUCCESS = "CREATE_SOURCE_SUCCESS";
export const CREATE_SOURCE_FAIL = "CREATE_SOURCE_FAIL";

export const GET_ROYALTIES_EDITOR = "GET_ROYALTIES_EDITOR";
export const GET_ROYALTIES_EDITOR_SUCCESS = "GET_ROYALTIES_EDITOR_SUCCESS";
export const GET_ROYALTIES_EDITOR_FAIL = "GET_ROYALTIES_EDITOR_FAIL";
export const GET_ROYALTIES_PHOTO = "GET_ROYALTIES_PHOTO";
export const GET_ROYALTIES_PHOTO_SUCCESS = "GET_ROYALTIES_PHOTO_SUCCESS";
export const GET_ROYALTIES_PHOTO_FAIL = "GET_ROYALTIES_PHOTO_FAIL";
export const GET_ROYALTIES_LIST = "GET_ROYALTIES_LIST";
export const GET_ROYALTIES_LIST_SUCCESS = "GET_ROYALTIES_LIST_SUCCESS";
export const GET_ROYALTIES_LIST_FAIL = "GET_ROYALTIES_LIST_FAIL";

export const GET = "GET";
export const GET_SUCCESS = "GET_SUCCESS";
export const GET_ERROR = "GET_ERROR";
export const CREATE = "CREATE";
export const CREATE_SUCCESS = "CREATE_SUCCESS";
export const CREATE_ERROR = "CREATE_ERROR";
